var map = {
	"./ambulance_chaser.png": 8516,
	"./ambulance_chaser_s.png": 1606,
	"./back_stabber.png": 9322,
	"./back_stabber_s.png": 7580,
	"./bean_counter.png": 7002,
	"./bean_counter_s.png": 6012,
	"./big_wig.png": 7721,
	"./big_wig_s.png": 8603,
	"./bloodsucker.png": 5498,
	"./bloodsucker_s.png": 9324,
	"./bottom_feeder.png": 4672,
	"./bottom_feeder_s.png": 4842,
	"./cold_caller.png": 4365,
	"./cold_caller_s.png": 6839,
	"./corporate_raider.png": 7036,
	"./corporate_raider_s.png": 6062,
	"./double_talker.png": 7588,
	"./double_talker_s.png": 1462,
	"./downsizer.png": 1286,
	"./downsizer_s.png": 8624,
	"./flunky.png": 9238,
	"./flunky_s.png": 5760,
	"./glad_hander.png": 1550,
	"./glad_hander_s.png": 1416,
	"./head_hunter.png": 6842,
	"./head_hunter_s.png": 4300,
	"./legal_eagle.png": 2263,
	"./legal_eagle_s.png": 8537,
	"./loan_shark.png": 9397,
	"./loan_shark_s.png": 3231,
	"./micromanager.png": 9456,
	"./micromanager_s.png": 2602,
	"./money_bags.png": 35,
	"./money_bags_s.png": 3597,
	"./mover_and_shaker.png": 1049,
	"./mover_and_shaker_s.png": 8731,
	"./mr_hollywood.png": 78,
	"./mr_hollywood_s.png": 888,
	"./name_dropper.png": 8829,
	"./name_dropper_s.png": 3495,
	"./number_cruncher.png": 1597,
	"./number_cruncher_s.png": 9399,
	"./pencil_pusher.png": 414,
	"./pencil_pusher_s.png": 1464,
	"./penny_pincher.png": 5291,
	"./penny_pincher_s.png": 8901,
	"./robber_baron.png": 1120,
	"./robber_baron_s.png": 6762,
	"./short_change.png": 1836,
	"./short_change_s.png": 6238,
	"./spin_doctor.png": 4443,
	"./spin_doctor_s.png": 8533,
	"./telemarketer.png": 1952,
	"./telemarketer_s.png": 9754,
	"./the_big_cheese.png": 7459,
	"./the_big_cheese_s.png": 5005,
	"./the_mingler.png": 477,
	"./the_mingler_s.png": 4567,
	"./tightwad.png": 741,
	"./tightwad_s.png": 1615,
	"./two-face.png": 4773,
	"./two-face_s.png": 8639,
	"./yesman.png": 1242,
	"./yesman_s.png": 6332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7328;